import { render } from "./ArtRegister.vue?vue&type=template&id=7dd3d5f0&scoped=true"
import script from "./ArtRegister.vue?vue&type=script&lang=js"
export * from "./ArtRegister.vue?vue&type=script&lang=js"

import "./ArtRegister.vue?vue&type=style&index=0&id=7dd3d5f0&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dd3d5f0"]])

export default __exports__